/** @jsxImportSource @emotion/react */

import * as React from 'react'
import { css, jsx } from '@emotion/react'
import styled from '@emotion/styled'
import { Primary, mixins } from '@sphinx/components-styles'

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  underline?: boolean
  disabled?: boolean
}

const Hyperlink = styled.a<LinkProps>`
  ${mixins.body}
  color: ${Primary.navy[100]};
  text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
  outline-color: ${Primary.orange[100]};
  &:hover {
    text-decoration-line: underline;
    color: ${Primary.orange[80]};
  }
  &:active {
    text-decoration-line: underline;
    color: ${Primary.orange[100]};
  }
  ${({ disabled }) =>
    disabled &&
    css`
      cursor: default;
      color: ${Primary.navy[20]};
      pointer-events: none;
    `}
`

export const Link: React.FC<LinkProps> = (props) => (
  <Hyperlink
    tabIndex={props.disabled ? -1 : 0}
    onClick={(e) => {
      if (props.disabled) {
        e.preventDefault()
      }
      if (props.onClick) {
        props.onClick(e)
      }
    }}
    {...props}
  />
)
